import React from 'react'
import ContentLoader from 'react-content-loader'

export const MapLoader = props => (
  <ContentLoader viewBox='0 0 260 100' height={100} width={260} {...props}>
    <rect x='10' y='10' rx='0' ry='0' width='240' height='90' />
  </ContentLoader>
)
